import React from "react";
import classNames from "classnames";
import { GameContext } from "../../context/GameContext";

const Image = ({ obj, onClick }) => {
  const { userAnswer } = React.useContext(GameContext);
  const handleClick = (id, e) => {
    onClick(id, e);
  };
  const checkStatus = (index) => {
    var res;
    if (userAnswer.length > 0) {
      res = userAnswer.find((obj) => {
        return obj.id === index;
      });
    }
    if (!res) {
      return;
    }
    if (res) return true;
  };

  return (
    <div
      onClick={(e) => handleClick(obj.id, e)}
      className={classNames("desktop-question", {
        active: checkStatus(obj.id) === true,
      })}
    >
      {obj.border}
      {/* {checkStatus(obj.id) && (
        <div data-name={obj.name.toLowerCase()} className="question-done"></div>
      )} */}
    </div>
  );
};

export default Image;
